
import { getSchema, MergeField, MergeSchema } from '../../decorators';
import { ActivityEntityName, Entity } from '../../../../entities';

@MergeSchema({
    entity: ActivityEntityName.Site
})
export class SiteMergeData {
    @MergeField({
        displayName: 'Site Name'
    })
    name: string;

    @MergeField()
    fullAddress: string;

    @MergeField()
    phone: string;

    @MergeField()
    email: string;

    @MergeField({
        source: 'Reference (Place Id)'
    })
    placeId: string;

    customFields: any;
    manager: Entity;
    owner: Entity;
    contact: Entity;
    parent: Entity;
}

export const SiteMergeSchema = getSchema(SiteMergeData);